"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSeriesPointsDebugEnabled = isSeriesPointsDebugEnabled;
exports.logSeriesPoints = logSeriesPoints;
const PREFIX = '[lb:series]';
/** Set to true locally to re-enable series points troubleshooting. */
const SERIES_POINTS_DEBUG_ENABLED = false;
function isSeriesPointsDebugEnabled() {
    if (!SERIES_POINTS_DEBUG_ENABLED)
        return false;
    // Re-enable by setting SERIES_POINTS_DEBUG_ENABLED above, or uncomment below:
    // if (typeof window === 'undefined') return false;
    // try {
    //     return (
    //         localStorage.getItem('lb:seriesDebug') === '1' ||
    //         new URLSearchParams(window.location.search).get('seriesDebug') === '1'
    //     );
    // } catch {
    //     return false;
    // }
    return false;
}
function logSeriesPoints(scope, payload) {
    if (!isSeriesPointsDebugEnabled())
        return;
    console.info(`${PREFIX} ${scope}`, payload);
}
